export enum UnPasswordResultStatus {
  None = "none",
  Success = "success",
  Incorrect = "incorrect",
  Pending = "pending",
  Error = "error",
}
